/* ==========================================================================
   Closed Shop / Drop Access Landingpage — Countdown, Platz-Zaehler, Klaviyo
   --------------------------------------------------------------------------
   WICHTIG: Der Klaviyo-Request laeuft ueber XMLHttpRequest, NICHT ueber
   window.fetch. App-Scripts auf diesem Store (lb-selleasy.js,
   shop_events_listener) patchen window.fetch — siehe cart-drawer-gifts.js
   und pdp-code-deal.js. Ueber fetch kommen sonst 400er zurueck.

   Alle Werte kommen aus data-Attributen, die die Sections aus den
   Theme-Editor-Settings rendern. Kein hartcodiertes Datum hier.
   ========================================================================== */
(function () {
  'use strict';

  // Jede Section laedt dieses Script selbst, damit sie eigenstaendig bleibt.
  // Der Browser fuehrt identische src-Tags mehrfach aus — hier einmal abbrechen.
  if (window.ClosedShopInit) return;
  window.ClosedShopInit = true;

  /* ---------- Helpers ---------- */

  // Baut aus "2026-08-15 10:00" + "+02:00" ein Safari-taugliches ISO-Datum.
  function parseDate(raw, offset) {
    if (!raw) return null;
    var s = String(raw).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00:00';
    if (/T\d{2}:\d{2}$/.test(s)) s += ':00';
    if (!/(Z|[+-]\d{2}:?\d{2})$/.test(s)) s += (offset ? String(offset).trim() : '+02:00');
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function num(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* ---------- Countdown ---------- */

  function initCountdown(el) {
    if (el.csTimer) clearInterval(el.csTimer);

    var target = parseDate(el.getAttribute('data-target'), el.getAttribute('data-offset'));
    var expired = el.parentNode.querySelector('[data-cs-expired]');

    if (!target) {
      if (window.console) console.warn('[closed-shop] Ungueltiges Zieldatum:', el.getAttribute('data-target'));
      return;
    }

    var fields = {
      days: el.querySelector('[data-cs-days]'),
      hours: el.querySelector('[data-cs-hours]'),
      mins: el.querySelector('[data-cs-mins]'),
      secs: el.querySelector('[data-cs-secs]')
    };

    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff < 0) diff = 0;

      if (fields.days) fields.days.textContent = pad(Math.floor(diff / 86400000));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (fields.mins) fields.mins.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (fields.secs) fields.secs.textContent = pad(Math.floor((diff % 60000) / 1000));

      // Abgelaufen: Timer gegen den Ablauf-Text tauschen, falls gesetzt.
      if (diff === 0 && expired && expired.textContent.trim() !== '') {
        el.hidden = true;
        expired.hidden = false;
        clearInterval(el.csTimer);
        el.csTimer = null;
      }
    }

    tick();
    el.csTimer = setInterval(tick, 1000);
  }

  /* ---------- Platz-Zaehler (simuliert) ----------
     Zwei Modi, die Section waehlt automatisch:

     1. Stuetzstellen gesetzt (data-anchors) -> "noch verfuegbar".
        Die Zahl zaehlt herunter und trifft an jeder Stuetzstelle exakt den
        hinterlegten Wert, dazwischen wird linear interpoliert. Der Balken
        zeigt weiterhin den vergebenen Anteil, laeuft also voll.
        Format je Zeile (oder per Semikolon getrennt):  2026-08-09 00:00 = 6454

     2. Keine Stuetzstellen -> alter Modus "vergeben".
        Waechst zeitgesteuert von data-base bis data-total.
  */

  // "2026-08-09 00:00 = 6454" je Zeile -> [{t, v}], aufsteigend sortiert.
  function parseAnchors(raw, offset) {
    if (!raw) return [];
    return String(raw)
      .split(/[\n;]/)
      .map(function (line) {
        var parts = line.split('=');
        if (parts.length < 2) return null;
        var date = parseDate(parts[0], offset);
        // Tausenderpunkte in "6.454" mit wegwerfen, Vorzeichen ignorieren.
        var value = parseInt(parts[1].replace(/[^\d]/g, ''), 10);
        if (!date || isNaN(value)) return null;
        return { t: date.getTime(), v: value };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.t - b.t; });
  }

  // Linear zwischen den beiden umgebenden Stuetzstellen, ausserhalb geklemmt.
  function valueFromAnchors(anchors, now) {
    var last = anchors[anchors.length - 1];
    if (now <= anchors[0].t) return anchors[0].v;
    if (now >= last.t) return last.v;

    for (var i = 0; i < anchors.length - 1; i++) {
      var a = anchors[i];
      var b = anchors[i + 1];
      if (now >= a.t && now <= b.t) {
        if (b.t === a.t) return b.v;
        var frac = (now - a.t) / (b.t - a.t);
        return Math.round(a.v + (b.v - a.v) * frac);
      }
    }
    return last.v;
  }

  function initScarcity(el) {
    if (el.csTimer) clearInterval(el.csTimer);

    var offset = el.getAttribute('data-offset');
    var total = num(el.getAttribute('data-total'), 9999);
    var anchors = parseAnchors(el.getAttribute('data-anchors'), offset);

    var countEl = el.querySelector('[data-cs-count]');
    var totalEl = el.querySelector('[data-cs-total]');
    var fillEl = el.querySelector('[data-cs-fill]');

    if (totalEl) totalEl.textContent = total.toLocaleString('de-DE');

    var update;

    if (anchors.length >= 2) {
      // Modus "noch verfuegbar": Zahl sinkt, Balken zeigt das Gegenstueck.
      update = function () {
        var available = valueFromAnchors(anchors, Date.now());
        available = Math.max(0, Math.min(total, available));
        var taken = total - available;
        if (countEl) countEl.textContent = available.toLocaleString('de-DE');
        if (fillEl) fillEl.style.width = Math.min(100, (taken / total) * 100) + '%';
      };
    } else {
      // Modus "vergeben": alte Kurve zwischen Start und Zieltermin.
      var start = parseDate(el.getAttribute('data-start'), offset);
      var target = parseDate(el.getAttribute('data-target'), offset);
      var base = num(el.getAttribute('data-base'), 0);

      if (!start || !target || target <= start) {
        if (window.console) console.warn('[closed-shop] Platz-Zaehler: Start/Ziel ungueltig.');
        return;
      }
      if (base > total) base = total;

      update = function () {
        var now = Date.now();
        var frac = (now - start.getTime()) / (target.getTime() - start.getTime());
        frac = Math.max(0, Math.min(1, frac));
        var eased = Math.pow(frac, 0.65);
        // Stundenbasierter Wobble, damit die Zahl nicht linear aussieht.
        var wobble = (Math.floor(now / 3600000) % 7) * 3;
        var span = Math.max(0, total - base - 40);
        var value = Math.min(total, base + Math.floor(eased * span) + wobble);

        if (countEl) countEl.textContent = value.toLocaleString('de-DE');
        if (fillEl) fillEl.style.width = Math.min(100, (value / total) * 100) + '%';
      };
    }

    update();
    el.csTimer = setInterval(update, 60000);
  }

  /* ---------- FAQ ---------- */

  function initFaq(el) {
    if (el.csBound) return;
    el.csBound = true;

    el.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cs-faq-q]');
      if (!btn || !el.contains(btn)) return;

      var item = btn.closest('.cs-faq__item');
      if (!item) return;

      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      var icon = btn.querySelector('[data-cs-faq-icon]');
      if (icon) icon.textContent = isOpen ? '−' : '+';
    });
  }

  /* ---------- Formular -> Klaviyo Client-API ---------- */

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function initForm(form) {
    if (form.csBound) return;
    form.csBound = true;

    var input = form.querySelector('[data-cs-email]');
    var trap = form.querySelector('[data-cs-trap]');
    var button = form.querySelector('[data-cs-submit]');
    var scope = form.closest('[data-cs-form-scope]') || form.parentNode;

    var errorEl = scope.querySelector('[data-cs-error]');
    var successEl = scope.querySelector('[data-cs-success]');
    var fineprintEl = scope.querySelector('[data-cs-fineprint]');
    var labelEl = scope.querySelector('[data-cs-signup-label]');

    var errorInvalid = form.getAttribute('data-error-invalid') || 'Bitte gib eine gültige E-Mail-Adresse ein.';
    var errorGeneric = form.getAttribute('data-error-generic') || 'Das hat nicht funktioniert. Bitte versuch es nochmal.';

    var companyId = (form.getAttribute('data-company-id') || '').trim();
    var listId = (form.getAttribute('data-list-id') || '').trim();
    var source = (form.getAttribute('data-source') || '').trim() || 'Closed Shop Landingpage';

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.classList.remove('is-visible');
    }

    function setLoading(state) {
      if (!button) return;
      button.classList.toggle('is-loading', state);
      button.disabled = state;
    }

    function showSuccess() {
      form.classList.add('is-hidden');
      if (fineprintEl) fineprintEl.classList.add('is-hidden');
      if (labelEl) labelEl.classList.add('is-hidden');
      if (successEl) successEl.classList.add('is-visible');
    }

    function subscribe(email, onDone) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            custom_source: source
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      var xhr = new XMLHttpRequest();
      xhr.open('POST', KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('revision', KLAVIYO_REVISION);
      xhr.timeout = 15000;

      xhr.onload = function () {
        // Klaviyo antwortet mit 202 Accepted.
        if (xhr.status >= 200 && xhr.status < 300) {
          onDone(true);
        } else {
          if (window.console) console.warn('[closed-shop] Klaviyo ' + xhr.status + ':', xhr.responseText);
          onDone(false);
        }
      };
      xhr.onerror = function () { onDone(false); };
      xhr.ontimeout = function () { onDone(false); };

      xhr.send(JSON.stringify(payload));
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (button && button.disabled) return;

      // Honeypot: von Bots ausgefuellt, von Menschen nie.
      if (trap && trap.value !== '') return;

      var email = input ? input.value.trim() : '';

      if (!isValidEmail(email)) {
        showError(errorInvalid);
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        return;
      }

      clearError();
      if (input) input.removeAttribute('aria-invalid');

      if (!companyId || !listId) {
        showError(errorGeneric);
        if (window.console) console.warn('[closed-shop] Klaviyo Public API Key oder List-ID fehlt im Theme-Editor.');
        return;
      }

      setLoading(true);
      subscribe(email, function (ok) {
        setLoading(false);
        if (ok) {
          showSuccess();
        } else {
          showError(errorGeneric);
        }
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        clearError();
        input.removeAttribute('aria-invalid');
      });
    }
  }

  /* ---------- Init ---------- */

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cs-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-cs-scarcity]').forEach(initScarcity);
    scope.querySelectorAll('[data-cs-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-cs-form]').forEach(initForm);
  }

  function teardown(root) {
    if (!root) return;
    root.querySelectorAll('[data-cs-countdown], [data-cs-scarcity]').forEach(function (el) {
      if (el.csTimer) {
        clearInterval(el.csTimer);
        el.csTimer = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme-Editor: Sections werden neu gerendert, Timer muessen mitziehen.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { teardown(event.target); });
})();
